import * as v from 'valibot';

// Runtime environment validation schema
const envSchema = v.object({
	// Medplum configuration
	VITE_MEDPLUM_BASE_URL: v.pipe(
		v.string('VITE_MEDPLUM_BASE_URL is required'),
		v.url('VITE_MEDPLUM_BASE_URL must be a valid URL'),
	),
	VITE_MEDPLUM_CLIENT_ID: v.pipe(
		v.string('VITE_MEDPLUM_CLIENT_ID is required'),
		v.minLength(1, 'VITE_MEDPLUM_CLIENT_ID cannot be empty'),
	),
	// Development configuration
	VITE_APP_ENV: v.optional(
		v.union([v.literal('development'), v.literal('staging'), v.literal('production')]),
		'development',
	),
	VITE_LOG_LEVEL: v.optional(
		v.union([
			v.literal('debug'),
			v.literal('info'),
			v.literal('warn'),
			v.literal('error'),
			v.literal('none'),
		]),
		'info',
	),
});

// Validate and export environment variables
function validateRuntimeEnv() {
	try {
		return v.parse(envSchema, import.meta.env);
	} catch (error) {
		if (error instanceof v.ValiError) {
			// eslint-disable-next-line no-restricted-syntax
			console.error('Environment validation failed at runtime:');
			for (const issue of error.issues) {
				// @ts-expect-error unneeded check on issue path
				// eslint-disable-next-line no-restricted-syntax
				console.error(`${issue.path?.map((p) => p.key).join('.') || 'root'}: ${issue.message}`);
			}
			throw new Error('Invalid environment configuration');
		}
		throw error;
	}
}

// Validated environment variables
export const env = validateRuntimeEnv();

// Type export for use in other files
export type Env = typeof env;
